import MuiMenu from "@mui/material/Menu";

import { colors } from "@dotnet/telematics-design-system";

import { centeredAnchorOrigin, centeredTransformOrigin } from "./shared";
import { CombinedMenuProps } from "./types";

const Menu = ({ ref, children, ...props }: CombinedMenuProps) => {
    const { gray200, white } = colors;

    return (
        <MuiMenu
            {...props}
            slotProps={{
                ...props.slotProps,
                paper: {
                    ...props.slotProps?.paper,
                    ref
                }
            }}
            sx={{
                "& .MuiMenu-paper": {
                    background: white,
                    border: `1px solid ${gray200}`,
                    borderRadius: "6px",
                    boxShadow: "0px 2px 8px rgba(15, 23, 42, 0.16)"
                },

                "& .MuiMenu-list": {
                    padding: "0"
                }
            }}
        >
            {children}
        </MuiMenu>
    );
};

export default Menu;
export { centeredAnchorOrigin, centeredTransformOrigin };
